<template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closedDialog()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Agendamento</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="closedDialog()">Salvar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
          <v-flex xs6 sm6 offset-sm3>
        <v-list three-line subheader>
          <v-subheader>Horário</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Selecione a hora</v-list-tile-title>
              <v-list-tile-sub-title>
                <v-flex xs11 sm5>
                  <v-dialog
                    ref="dialog"
                    v-model="modal2"
                    :return-value.sync="time"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time"
                        label="Picker in dialog"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="modal2"
                      v-model="time"
                      full-width
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog.save(time)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Selecione a Data</v-list-tile-title>
              <v-list-tile-sub-title>
                <v-flex xs12 sm6 md4>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Click para abrir a caixa"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
          </v-flex>
        <v-divider></v-divider>

        <form>
          <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
          <v-flex xs6 sm6 offset-sm3>
            <v-checkbox
              v-model="registered"
              label="Paciente Cadastrado?"
            ></v-checkbox>
            <v-text-field 
              v-if="!registered"
              label="Nome"
            ></v-text-field>            
            <v-text-field 
              v-if="registered"
              v-model="message"
              :append-icon="model ? 'arrow_back' : ''"
              :append-outer-icon="message ? 'mdi-send' : 'search'"
              :prepend-icon="icon"
              box
              clear-icon="mdi-close-circle"
              clearable
              label="Paciente/Dt Nascimento"
              type="text"
              @click:append="toggleMarker"
              @click:append-outer="sendMessage"
              @click:prepend="changeIcon"
              @click:clear="clearMessage"
            ></v-text-field>

            <v-progress-linear :indeterminate="true" v-show="loadingOk === true"></v-progress-linear>

            <v-list two-line v-if="!model" v-show="listVisible">
              <template v-for="(item, index) in items">
                <v-subheader
                  v-if="item.header"
                  :key="item.header"
                >
                  Selecione o nome
                  <!-- {{ item.header }} -->
                </v-subheader>

                <v-divider
                  v-else-if="item.divider"
                  :key="index"
                  :inset="item.inset"
                ></v-divider>

                <v-list-tile
                  v-else
                  :key="item.id"
                  avatar
                  @click="selectPatient(item)"
                >
                  <v-list-tile-avatar color="indigo">
                    <span class="white--text headline">{{item.symbol}}</span>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.dateOfBirth"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>              

            <v-text-field
              v-model="email"
              v-validate="'required|email'"
              :error-messages="errors.collect('email')"
              label="Celular"
              data-vv-name="email"
              required
            ></v-text-field>
            <v-select
              v-model="select"
              v-validate="'required'"
              :items="items"
              :error-messages="errors.collect('select')"
              label="Convênio"
              data-vv-name="select"
              required
            ></v-select>
            <v-btn @click="submit">Salvar</v-btn>
            <v-btn @click="clear">Cancelar</v-btn>
            </v-flex>
            </v-layout>
           </v-container>
        </form>

      </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import store from '../../store'

  export default {
    computed: {
      ...mapGetters('app', ['getTheme', 'getDevice']),
      icon () {
        return this.icons[this.iconIndex]
      }
    },
    data () {
      return {
        registered: false,
        loadingOk: false,
        message: '',
        listVisible: false,
        iconIndex: 0,
        icons: [
          'mdi-emoticon',
          'mdi-emoticon-cool',
          'mdi-emoticon-dead',
          'mdi-emoticon-excited',
          'mdi-emoticon-happy',
          'mdi-emoticon-neutral',
          'mdi-emoticon-sad',
          'mdi-emoticon-tongue'
        ],
        env: null,
        date: new Date().toISOString().substr(0, 10),
        time: '11:10',
        menu: false,
        menu2: false,
        model: null,
        modal: false,
        modal2: false,
        name: '',
        email: '',
        select: null,
        items: [
          'Item 1',
          'Item 2',
          'Item 3',
          'Item 4'
        ],
        checkbox: null,
        dictionary: {
          attributes: {
            email: 'E-mail Address'
            // custom attributes
          },
          custom: {
            name: {
              required: () => 'Name can not be empty',
              max: 'The name field may not be greater than 10 characters'
              // custom messages
            },
            select: {
              required: 'Select field is required'
            }
          },
          dialog: false,
          notifications: false,
          sound: true,
          widgets: false
        }
      }
    },
    methods: {
      ...mapActions('patient', ['setPatient']),
      findOne () {
        if ((this.model === null) || (this.model === undefined)) return
        this.setPatient(this.model).then(() => {
          console.log(this.model)
        })
      },
      selectPatient (item) {
        this.model = item.id
        this.findOne()
      },
      toggleMarker () {
        this.model = undefined
        this.show(0)
        // this.marker = !this.marker
      },
      sendMessage () {
        this.loadingOk = true
        window.axios.get(`${process.env.URL}/my-clinic-new/patient/find`, {
          params: {
            patient: this.message,
            customer: store.state.customer
          }
        }).then((response) => {
          // handle success
          this.items = response.data.results.results.map((item) => {
            return {
              id: item.tbCodigo,
              name: item.tbNome,
              symbol: item.tbNome.substr(0, 1),
              website_slug: 'spitzer.io',
              dateOfBirth: item.tbDtNasc
            }
          })
          this.listVisible = true
          this.loadingOk = false
        })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
      },
      clearMessage () {
        this.listVisible = false
        this.message = ''
        this.navigation = 'list'
        this.show(0)
      },
      resetIcon () {
        this.iconIndex = 0
      },
      changeIcon () {
        this.iconIndex === this.icons.length - 1
          ? this.iconIndex = 0
          : this.iconIndex++
      },
      closedDialog () {
        this.$bus.$emit('closeDialogSchedule', false)
      },
      submit () {
        this.$validator.validateAll()
      },
      clear () {
        this.name = ''
        this.email = ''
        this.select = null
        this.checkbox = null
        this.$validator.reset()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/schedule/create.vue